let defId = 1;

export default function definitionId() {
    return "kdef" + defId++;
}